import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { MarkdownRendererInlineEditExample } from '../markdown-renderer-inline-edit/example';
import { MarkdownRenderer } from '@/components/shared/markdown-renderer';

const markdown = `
# Heading 1

This is a paragraph.

## Heading 2

This is a paragraph with a **bold**, _italic_ and ~~deleted text~~ text in the middle.

### Regular unordered list (heading 3)

- list
- list2

#### Regular ordered list (heading 4)

1. list
2. list2

##### Task list (heading 5)

- [ ] Irure anim minim magna anim in irure et adipisicing cupidatat adipisicing quis enim nisi nostrud voluptate. Reprehenderit non sunt ipsum reprehenderit quis tempor occaecat culpa. Occaecat amet consectetur sit velit est ea quis incididunt ad dolor nostrud anim. Proident ullamco elit anim tempor duis in aliqua cillum anim do. Reprehenderit fugiat dolor minim elit occaecat excepteur minim non.

- [x] bar

###### Table (heading 6)

| Header | Header |
| ------ | ------ |
| Body   | Body   |
| Body   | Body   |
`;

export const MarkdownRendererExample = () => {
  const [tab, setTab] = useState(0);

  return (
    <>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        aria-label="MarkdownRenderer variants"
      >
        <Tab label="Default style" />
        <Tab label="Custom style" />
        <Tab label="No content" />
        <Tab label="Inline edit" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <MarkdownRenderer markdown={markdown} />}
        {tab === 1 && (
          <Box
            sx={(theme) => ({
              '&& .remirror-editor': {
                '& p': {
                  color: 'blue',
                },
                h1: {
                  fontSize: theme.typography.h6.fontSize,
                  color: 'red',
                },
                h2: {
                  fontSize: theme.typography.h5.fontSize,
                  color: 'black',
                },
                h3: {
                  fontSize: theme.typography.h4.fontSize,
                  color: 'green',
                },
                h4: {
                  fontSize: theme.typography.h3.fontSize,
                  color: 'purple',
                },
                h5: {
                  fontSize: theme.typography.h2.fontSize,
                  color: 'orange',
                },
                h6: {
                  fontSize: theme.typography.h1.fontSize,
                  color: 'brown',
                },
              },
            })}
          >
            <MarkdownRenderer markdown={markdown} />
          </Box>
        )}
        {tab === 2 && (
          <MarkdownRenderer
            markdown=""
            placeholder="Empty content placeholder text"
          />
        )}
        {tab === 3 && <MarkdownRendererInlineEditExample />}
      </Box>
    </>
  );
};
